import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type {
  CreateAffiliateCodeRequest,
  CreateAffiliateCodeResponse,
} from './create-affiliate-code.types'

const createAffiliateCode = async (
  data: CreateAffiliateCodeRequest,
): Promise<CreateAffiliateCodeResponse> => {
  const response = await apiClient.post<CreateAffiliateCodeResponse>(
    '/v1/affiliation/codes',
    data,
  )
  return response.data
}

interface UseCreateAffiliateCodeOptions {
  feedback?: MutationFeedback
}

export const useCreateAffiliateCode = (
  options?: UseCreateAffiliateCodeOptions,
) => {
  return useMutation({
    mutationFn: createAffiliateCode,
    meta: {
      invalidatesQuery: ['affiliate-codes'],
      ...options?.feedback,
    },
  })
}
